module.exports = {
    message: {
        title: 'Sport Brands'
    },
    navs: {
        nav1:'Home Page',
        nav3:'Union Members',
        nav8:'Sponsor',
        nav4:'Exhibition & Communication',
        nav5:'Forum Article',
        nav9:'Contact Us',
        nav7:'Membership Application',
        nav2:'Union',
        nav6:'Art Works Show',
    },
    footerItem1:{
        id:1,
        title:"About US",
        des:'During the 4th China Changchun World Sculpture, initiated by Changchun-World-Sculpture-Park of China,  art-st-urban of Switzerland, Chianti Sculpture Park of Italy, Beddington Fine Art Gallery Gardens of France.'
    },
    footerItem2:{
        id:2,
        title:"Contact Us",
        des:'Union Secretariat：',
        phoneNo:'+86 431 85379019',
        email:'ISPU_members@163.com',
        addr:'9518 Renmin Stress, Changchun P.R.China'
    },
    footerItem3:{
        id:3,
        title:"FastLink",
        
    },
    footerItem4:{
        title:"Membership Application",
        des:'Please download The Application Document and send The Email  to   ISPU_members@163.com'
    },
    footerNav:{
        nav1:'Home Page',
        nav2:'Forum Article',
        nav3:'Union Members',
        nav4:'Exhibition & Communication',
        nav5:'Art Works Show',
        nav6:'Union',
        nav7:'Sponsor',
        nav8:'Forum Article',
        


        // nav1:'Home Page',
        // nav2:'Union',
        // nav3:'Union Members',
        // nav4:'Art Works Show',
        // nav5:'Forum Article',
        // nav6:'Sponsor',
        // nav7:'Exhibition & Communication',
    }
}